@let hasTrainingQualificationCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.QualificationTraining);
<button
  nz-button
  nzType="default"
  (click)="showTrainingQualificationCreateDrawer()"
  [disabled]="!hasTrainingQualificationCreatePermission"
  nz-tooltip
  [nzTooltipTitle]="'general.no_permissions' | translate"
  [nzTooltipTrigger]="
    !hasTrainingQualificationCreatePermission ? 'hover' : null
  "
>
  {{ 'general.add' | translate }}
</button>
